import React, { useState, useEffect } from 'react';
import { getLMSTokenRequest, VEEFIN_DASHBOARD_URL } from "@/services";
import { useParams, useNavigate } from 'react-router-dom';

const styles = {
  container: {
    position: 'fixed',
    top: '65px',
    left: 0,
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  }
};

function InvoiceErrorView({ message, onBackHome }) {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center p-4"
      style={{ minHeight: 'calc(100vh - 65px)', width: '100%' }}
    >
      <p className="text-danger text-center mb-3 px-3">{message}</p>
      <button type="button" className="btn btn-primary" onClick={onBackHome}>
        Back to home
      </button>
    </div>
  );
}

export function InvoiceDashboard() {
  const { loanUuid } = useParams();
  const navigate = useNavigate();
  const trimmedLoanUuid = (loanUuid ?? '').trim();

  const [iframeUrl, setIframeUrl] = useState('');
  const [loading, setLoading] = useState(!!trimmedLoanUuid);
  const [loadError, setLoadError] = useState(null);

  const goHome = () => navigate('/home');

  useEffect(() => {
    if (!trimmedLoanUuid) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setLoadError(null);
    setIframeUrl('');

    async function fetchTokenAndSetUrl() {
      try {
        const response = await getLMSTokenRequest({ loan_id: trimmedLoanUuid });
        if (cancelled) return;
        if (response?.success && response?.results?.token) {
          setIframeUrl(`${VEEFIN_DASHBOARD_URL}/API/v1/fincobox_login_SSO?edata=${response?.results?.token}`);
        } else {
          setLoadError(
            response?.error?.message
            || response?.message
            || 'Unable to load the invoice dashboard. This loan may not exist or you may not have access.'
          );
        }
      } catch (error) {
        if (!cancelled) {
          console.error('Error fetching token:', error);
          setLoadError(
            error?.message || 'Something went wrong while loading the invoice dashboard.'
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchTokenAndSetUrl();
    return () => {
      cancelled = true;
    };
  }, [trimmedLoanUuid]);

  if (!trimmedLoanUuid) {
    return (
      <div style={styles.container}>
        <InvoiceErrorView
          message="Loan reference was not found in the URL."
          onBackHome={goHome}
        />
      </div>
    );
  }

  if (loadError) {
    return (
      <div style={styles.container}>
        <InvoiceErrorView message={loadError} onBackHome={goHome} />
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          style={styles.iframe}
          frameBorder="0"
          allowFullScreen
          title="Invoice dashboard"
        />
      ) : (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
          <p className="text-muted text-center mb-0">Loading...</p>
        </div>
      )}
    </div>
  );
}
